import { createBrowserRouter, Navigate } from 'react-router';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Login from './components/auth/Login';
import Callback from './components/auth/Callback';
import Dashboard from './components/Dashboard';
import CampaignList from './components/CampaignList';
import NewCampaign from './components/NewCampaign';
import CampaignDetail from './components/CampaignDetail';
import AppLayout from './components/layout/AppLayout';
import UserManagementPage from './components/users/UserManagementPage';

export const router = createBrowserRouter(
  [
    {
      path: '/index.html',
      element: <Navigate to="/" replace />,
    },
    {
      path: '/login',
      element: <Login />,
    },
    {
      path: '/callback',
      element: <Callback />,
    },
    {
      path: '/',
      element: <ProtectedRoute />,
      children: [
        {
          path: '',
          element: <AppLayout />,
          children: [
            {
              index: true,
              element: <Dashboard />,
            },
            {
              path: 'campaigns',
              element: <CampaignList />,
            },
            {
              path: 'campaigns/:id',
              element: <CampaignDetail />,
            },
            {
              path: 'new-campaign',
              element: <NewCampaign />,
            },
            {
              path: 'users',
              element: <ProtectedRoute requiredRole="SystemAdministrators" />,
              children: [
                {
                  index: true,
                  element: <UserManagementPage />,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  {
    basename: import.meta.env.PUBLIC_URL ?? '/',
  }
);
